module.exports = __webpack_public_path__ + "static/media/share.6dfacf24.svg";